import { IApplicationState } from '../../types/redux';
import { getQuestionById } from './getQuestionById';

export const getIsQuestionAuthorAnonymousById =
  (id: string) =>
  (state: IApplicationState): boolean => {
    const question = getQuestionById(id)(state);

    return question?.isAnonymous;
  };
